import React, {useState} from 'react'
import {Helmet} from "react-helmet";
import {useNavigate} from 'react-router-dom';
import Navbar from './components/Navbar'
import Footer from './components/Footer'

const today = new Date().toISOString().split('T')[0];

const Contact = () => {
	const navigate = useNavigate();
	const [status, setStatus] = useState(null);
	const [formData, setFormData] = useState({
		role: '',
		firstName: '',
		lastName: '',
		email: '',
		instagram: '',
		phone: '',
		weddingDate: '',
		weddingLocation: '',
		aboutWedding: '',
		whyUs: '',
	});

	const contactForm = async (e) => {
		e.preventDefault();
		setStatus('loading');

		try {
			const response = await fetch(`${process.env.REACT_APP_API_URL}/contact`, {
				method: "POST",
				headers: {
					"Content-Type": "application/json",
					Accept: "application/json",
				},
				body: JSON.stringify(formData),
			});

			const result = await response.json();
			if (result.success) {
				navigate('/thank-you', { state: { source: 'contact' } });
			} else {
				setStatus('error');
			}
		} catch (error) {
			console.error("Error:", error);
			setStatus('error');
		}
	};

	const handleInputChange = (e) => {
		const { name, value } = e.target;
		setFormData((prevData) => ({
			...prevData,
			[name]: value,
		}));
	};

	const inputClass = `
		border-solid border-b border-gray-400
		text-sm text-black w-full tracking-[.1em]
		focus:outline-none focus:border-black
		bg-transparent py-2 transition-colors duration-200
	`;

	const labelClass = `block text-xs tracking-[.2em] text-custom-gray-head-text mb-2`;

	return (
		<>
			<Helmet>
				<title>Contact Glintz Media | Book Your UK Photography Session</title>
				<meta name="description" content="Connect with Glintz Media to book your wedding, commercial, or portrait photography session in Manchester and across the UK. Request a consultation today." />
			</Helmet>
			<Navbar />

			{/* ── HERO SECTION ── */}
			<div className="relative w-full xl:h-[85vh] lg:h-[75vh] md:h-[60vh] h-[50vh] overflow-hidden">
				{/* Background image */}
				<img
					src="https://images.unsplash.com/photo-1590004953392-5aba2e72269a?q=80&w=2000&auto=format&fit=crop"
					alt="Behind the scenes studio setup"
					className="absolute inset-0 w-full h-full object-cover object-center"
				/>
				{/* Dark overlay */}
				<div className="absolute inset-0 bg-black bg-opacity-50" />
				{/* Hero text */}
				<div className="absolute inset-0 flex flex-col items-center justify-center text-center xl:px-40 lg:px-20 px-8">
					<p className="text-white text-xs tracking-[.35em] uppercase mb-6 opacity-80" style={{fontFamily: "Muli"}}>
						Glintz Media — United Kingdom
					</p>
					<h1 className="text-white uppercase xl:text-5xl lg:text-4xl md:text-3xl text-2xl tracking-[.15em] leading-tight mb-6">
						Connect with Glintz Media
					</h1>
					<div className="w-12 h-px bg-white opacity-60 mb-6" />
					<p className="text-white xl:text-base lg:text-base md:text-sm text-sm tracking-wide opacity-90 max-w-2xl" style={{fontFamily: "Muli"}}>
						We are currently accepting commissions for weddings, commercial campaigns, and documentary projects across the UK and internationally.
					</p>
				</div>
			</div>

			{/* ── MAIN CONTENT ── */}
			<div className="bg-custom-light-bg" style={{backgroundImage:"url(https://solene.qodeinteractive.com/wp-content/uploads/2019/12/contact-2-bckgr-img.png)"}}>

				{/* ── INQUIRY FORM SECTION ── */}
				<div className="bg-white xl:mx-40 lg:mx-20 mx-5 xl:px-[10%] lg:px-20 md:px-12 px-6 py-16 mt-16">

					{/* Section heading */}
					<div className="text-center mb-12">
						<p className="text-xs tracking-[.35em] uppercase text-custom-gray-text mb-4" style={{fontFamily: "Muli"}}>
							Limited Commissions Available
						</p>
						<h2 className="uppercase xl:text-3xl lg:text-3xl md:text-2xl text-2xl tracking-[.15em] text-custom-gray-head-text mb-6">
							Start the Conversation
						</h2>
						<div className="w-10 h-px bg-gray-400 mx-auto mb-6" />
						<p className="text-custom-gray-text max-w-xl mx-auto text-sm leading-relaxed" style={{fontFamily: "Muli"}}>
							To ensure every client receives our full creative focus, we accept a limited number of commissions each year. Please provide as much detail as possible about your upcoming project or celebration. We aim to respond to all inquiries within 48 hours.
						</p>
					</div>

					<form onSubmit={contactForm}>
						<div className="grid xl:grid-cols-2 lg:grid-cols-2 md:grid-cols-2 grid-cols-1 gap-x-8 gap-y-8">

							{/* Role */}
							<div>
								<label className={labelClass} style={{fontFamily: "Muli"}}>ROLE *</label>
								<select
									className={inputClass}
									name="role"
									value={formData.role}
									onChange={handleInputChange}
									style={{fontFamily: "Muli"}}
									required
								>
									<option value="">Select</option>
									<option value="bride">Bride</option>
									<option value="groom">Groom</option>
									<option value="couple">Couple</option>
									<option value="event-planner">Event Planner</option>
									<option value="corporate">Corporate</option>
									<option value="other">Other</option>
								</select>
							</div>

							{/* First Name */}
							<div>
								<label className={labelClass} style={{fontFamily: "Muli"}}>FIRST NAME *</label>
								<input
									className={inputClass}
									type="text"
									name="firstName"
									value={formData.firstName}
									onChange={handleInputChange}
									style={{fontFamily: "Muli"}}
									required
								/>
							</div>

							{/* Last Name */}
							<div>
								<label className={labelClass} style={{fontFamily: "Muli"}}>LAST NAME *</label>
								<input
									className={inputClass}
									type="text"
									name="lastName"
									value={formData.lastName}
									onChange={handleInputChange}
									style={{fontFamily: "Muli"}}
									required
								/>
							</div>

							{/* Email */}
							<div>
								<label className={labelClass} style={{fontFamily: "Muli"}}>EMAIL ADDRESS *</label>
								<input
									className={inputClass}
									type="email"
									name="email"
									value={formData.email}
									onChange={handleInputChange}
									style={{fontFamily: "Muli"}}
									required
								/>
								{formData.email.length > 0 &&
									!/[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}/.test(formData.email) && (
										<span className="text-red-500 text-xs mt-1 block" style={{fontFamily: "Muli"}}>Invalid email format</span>
								)}
							</div>

							{/* Instagram */}
							<div>
								<label className={labelClass} style={{fontFamily: "Muli"}}>INSTAGRAM HANDLE <span className="opacity-50">(OPTIONAL)</span></label>
								<input
									className={inputClass}
									type="text"
									name="instagram"
									value={formData.instagram}
									onChange={handleInputChange}
									placeholder="@yourhandle"
									style={{fontFamily: "Muli"}}
								/>
							</div>

							{/* UK Phone */}
							<div>
								<label className={labelClass} style={{fontFamily: "Muli"}}>UK PHONE NUMBER (+44) *</label>
								<input
									className={inputClass}
									type="tel"
									name="phone"
									value={formData.phone}
									onChange={handleInputChange}
									placeholder="+44"
									style={{fontFamily: "Muli"}}
									required
								/>
							</div>

							{/* Wedding Date */}
							<div>
								<label className={labelClass} style={{fontFamily: "Muli"}}>WEDDING / EVENT DATE *</label>
								<input
									className={inputClass}
									type="date"
									name="weddingDate"
									value={formData.weddingDate}
									onChange={handleInputChange}
									min={today}
									style={{fontFamily: "Muli", colorScheme: "light"}}
									required
								/>
							</div>

							{/* Wedding Location */}
							<div className="xl:col-span-2 lg:col-span-2 md:col-span-2">
								<label className={labelClass} style={{fontFamily: "Muli"}}>WEDDING / EVENT LOCATION *</label>
								<input
									className={inputClass}
									type="text"
									name="weddingLocation"
									value={formData.weddingLocation}
									onChange={handleInputChange}
									placeholder="City, Country"
									style={{fontFamily: "Muli"}}
									required
								/>
							</div>
						</div>

						{/* About Wedding */}
						<div className="mt-8">
							<label className={labelClass} style={{fontFamily: "Muli"}}>TELL US ABOUT YOUR WEDDING / EVENT *</label>
							<textarea
								rows="5"
								className="focus:outline-none focus:border-black block w-full shadow-sm sm:text-sm border-b border-gray-400 py-2 bg-transparent resize-none"
								name="aboutWedding"
								value={formData.aboutWedding}
								onChange={handleInputChange}
								style={{fontFamily: "Muli"}}
								required
								placeholder="Describe your event, theme, number of guests, and any specific requirements..."
							/>
						</div>

						{/* Why Us */}
						<div className="mt-8">
							<label className={labelClass} style={{fontFamily: "Muli"}}>WHY CHOOSE GLINTZ MEDIA? *</label>
							<textarea
								rows="3"
								className="focus:outline-none focus:border-black block w-full shadow-sm sm:text-sm border-b border-gray-400 py-2 bg-transparent resize-none"
								name="whyUs"
								value={formData.whyUs}
								onChange={handleInputChange}
								style={{fontFamily: "Muli"}}
								required
								placeholder="What attracted you to our work?"
							/>
						</div>

						<div className="mt-10 flex flex-col items-center gap-4">
							<button
								type="submit"
								disabled={status === 'loading'}
								className="bg-custom-dark-gray-bg px-16 py-3 tracking-[.3em] text-xs text-white uppercase hover:bg-opacity-90 transition-all disabled:opacity-50"
								style={{fontFamily: "Muli"}}
							>
								{status === 'loading' ? 'SENDING…' : 'SEND INQUIRY'}
							</button>
							{status === 'error' && (
								<p className="text-red-500 text-xs tracking-[.15em] text-center" style={{fontFamily: "Muli"}}>
									Something went wrong. Please try again, or email us directly at temitope@glintzphotography.org
								</p>
							)}
						</div>
					</form>
				</div>

				{/* ── DIRECT CONTACT STRIP ── */}
				<div className="xl:mx-40 lg:mx-20 mx-5 mt-0 mb-0">
					<div className="bg-custom-dark-gray-bg xl:px-[10%] lg:px-20 md:px-12 px-6 py-12">
						<h3 className="uppercase text-center text-white tracking-[.25em] text-sm mb-10" style={{fontFamily: "Muli"}}>
							Direct Contact Information
						</h3>
						<div className="grid xl:grid-cols-4 md:grid-cols-2 grid-cols-1 gap-8 text-center">
							{/* Email */}
							<div>
								<div className="flex justify-center mb-3">
									<img width="32" height="32" src="https://img.icons8.com/glyph-neue/32/ffffff/new-post.png" alt="email" />
								</div>
								<p className="text-gray-400 text-xs tracking-[.15em] uppercase mb-1" style={{fontFamily: "Muli"}}>Email</p>
								<a className="text-white text-xs" style={{fontFamily: "Muli"}} href="mailto:temitope@glintzphotography.org">
									temitope@glintzphotography.org
								</a>
							</div>
							{/* Phone */}
							<div>
								<div className="flex justify-center mb-3">
									<img width="32" height="32" src="https://img.icons8.com/ios/32/ffffff/phone--v1.png" alt="phone" />
								</div>
								<p className="text-gray-400 text-xs tracking-[.15em] uppercase mb-1" style={{fontFamily: "Muli"}}>Phone</p>
								<a className="text-white text-xs" style={{fontFamily: "Muli"}} href="tel:+447823683844">
									+44 782 368 3844
								</a>
							</div>
							{/* HQ */}
							<div>
								<div className="flex justify-center mb-3">
									<img width="32" height="32" src="https://img.icons8.com/ios-filled/32/ffffff/address--v1.png" alt="location" />
								</div>
								<p className="text-gray-400 text-xs tracking-[.15em] uppercase mb-1" style={{fontFamily: "Muli"}}>Headquarters</p>
								<p className="text-white text-xs" style={{fontFamily: "Muli"}}>Manchester, United Kingdom</p>
							</div>
							{/* Hours */}
							<div>
								<div className="flex justify-center mb-3">
									<img width="32" height="32" src="https://img.icons8.com/ios/32/ffffff/clock--v1.png" alt="hours" />
								</div>
								<p className="text-gray-400 text-xs tracking-[.15em] uppercase mb-1" style={{fontFamily: "Muli"}}>Operating Hours</p>
								<p className="text-white text-xs" style={{fontFamily: "Muli"}}>Mon – Fri, 9:00 AM – 6:00 PM (GMT)</p>
							</div>
						</div>

						{/* Instagram */}
						<div className="mt-10 flex justify-center">
							<a
								href="https://instagram.com/glintzweddingphotography"
								target="_blank"
								rel="noreferrer"
								className="flex items-center gap-3 text-white opacity-70 hover:opacity-100 transition-opacity"
								style={{fontFamily: "Muli"}}
							>
								<img width="20" height="20" src="https://img.icons8.com/ios/20/ffffff/instagram-new--v1.png" alt="instagram" />
								<span className="text-xs tracking-[.2em]">@glintzweddingphotography</span>
							</a>
						</div>
					</div>
				</div>

				{/* ── CONSULTATION INFO SECTION ── */}
				<div className="xl:mx-[20px] lg:mx-20 mx-5 bg-white xl:px-[10%] lg:px-20 md:px-12 px-6 py-16 mb-16">
					<div className="xl:flex lg:flex items-start gap-16">
						<div className="xl:w-1/3 lg:w-1/3 mb-8 xl:mb-0 lg:mb-0">
							<p className="text-xs tracking-[.35em] uppercase text-custom-gray-text mb-4" style={{fontFamily: "Muli"}}>
								What to Expect
							</p>
							<h2 className="uppercase xl:text-2xl lg:text-2xl text-xl tracking-[.12em] text-custom-gray-head-text leading-snug">
								UK Photography Booking & Consultation Information
							</h2>
							<div className="w-8 h-px bg-gray-400 mt-6" />
						</div>
						<div className="xl:w-2/3 lg:w-2/3">
							<p className="text-custom-gray-text text-sm leading-relaxed" style={{fontFamily: "Muli"}}>
								Whether you are inquiring about a high-volume corporate branding shoot in Manchester or a multi-day destination wedding, our consultation process is transparent. Once we receive your brief, we will schedule a call to discuss your aesthetic goals, logistical requirements, and tailored pricing options.
							</p>
							<div className="grid md:grid-cols-3 grid-cols-1 gap-8 mt-10">
								<div>
									<p className="text-xs tracking-[.2em] uppercase text-custom-gray-head-text mb-2" style={{fontFamily: "Muli"}}>01 — Submit Brief</p>
									<p className="text-custom-gray-text text-xs leading-relaxed" style={{fontFamily: "Muli"}}>Complete the inquiry form with as much detail as possible about your project.</p>
								</div>
								<div>
									<p className="text-xs tracking-[.2em] uppercase text-custom-gray-head-text mb-2" style={{fontFamily: "Muli"}}>02 — Consultation Call</p>
									<p className="text-custom-gray-text text-xs leading-relaxed" style={{fontFamily: "Muli"}}>We schedule a call to align on aesthetic vision, logistics, and creative direction.</p>
								</div>
								<div>
									<p className="text-xs tracking-[.2em] uppercase text-custom-gray-head-text mb-2" style={{fontFamily: "Muli"}}>03 — Tailored Proposal</p>
									<p className="text-custom-gray-text text-xs leading-relaxed" style={{fontFamily: "Muli"}}>Receive a bespoke proposal with transparent pricing and deliverable timelines.</p>
								</div>
							</div>
						</div>
					</div>
				</div>

			</div>
			<Footer />
		</>
	)
}

export default Contact